<template>
    <div class="dp-fx fx-al-st pd-t-10 pd-b-10 pd-l-20 pd-r-20 post-comment bg-solitude cl-black">
        <div v-if="currentUser">
            <img v-if="currentUser.photoURL" :src="currentUser.photoURL" :alt="currentUser.displayName" class="br-rd-pr-50 user-img">
            <img v-else src="https://o.cdn.newsbytesapp.com/assets/people/na.2.jpg" :alt="currentUser.displayName" class="br-rd-pr-50 user-img">
        </div>
        <div v-else>
            <img src="https://o.cdn.newsbytesapp.com/assets/people/na.2.jpg" alt="User Placeholder" class="br-rd-pr-50 user-img">
        </div>
        <form @submit.prevent class="dp-fx fx-al-ct mg-l-10 fx-grow-1">
            <textarea rows="2" v-model.trim="post.content" class="post-text fz-14 lh-18 pd-t-6 pd-b-6 pd-l-6 pd-r-6 br-rd-10 fw-4" placeholder="Add a comment" maxlength="250" required></textarea>
            <button class="post-button fz-18 pd-l-10 pd-t-4 pd-b-4 cs-ptr" :disabled="post.content==''" @click="postComment">
                <img src="@/assets/post.png" height=18 alt="Post Icon"/>
            </button>
        </form>
    </div>
</template>

<script>

    import axios from "axios";
    import firebase from 'firebase';
    import {mapState} from 'vuex';
    const fb = require('../firebaseConfig.js')

    export default {
        name : 'PostComment',
        components : {},
        computed: {
            ...mapState(['userProfile', 'currentUser', 'commentsModalActive', 'comments', 'currentMovie'])
        },
        data: function (params) {
            return {
                post: {
                    content: '',
                },
                firstchar: '',
            }
        },
        methods: {
            postComment() {
                if (this.currentUser == null) {
                    this.$router.push('/login');
                }
                else if (this.post != '') {
                    let comment = {
                        createdOn: new Date(),
                        content: this.post.content,
                        userId: this.currentUser.uid,
                        userName: this.currentUser.displayName,
                        photoURL: this.currentUser.photoURL,
                        movieId: this.currentMovie.id,
                        likes: 0,
                        dislikes: 0,
                    };
                    fb.commentCollection.add(comment)
                    .then((ref) => {
                        this.post.content = '';
                        this.$store.dispatch('fetchMovieComments', { id : this.currentMovie.id })
                    })
                    .catch((err) => {
                        console.error(err.message)
                    })
                }
            }
        }
    }
</script>

<style>
    .post-comment{
        border-bottom: 1px solid #D6E1F3;
    }
    .post-comment .user-img{
        width: 38px;
        height: 38px;
    }
    .post-comment .post-text{
        overflow-x : hidden;
        resize: none;
        outline: none;
        height: auto;
        border: 0;
    }
    .post-comment .post-text::placeholder{
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #000000;
    }
    .post-comment .post-button{
        color: #2a629c;
    }
</style>